import {
  Component,
  computed,
  inject,
  PLATFORM_ID, // 1. Import Platform ID
} from '@angular/core';
import { Page } from '../../page/page';
import {
  PluginState,
  SurveyRenderControllerStore,
} from '../../render-store/render.store';
import { UnifiedSurveyStore } from '../../render-store/unified-survey.store';
import { InteractionTypes } from '@hyper-inferno/survey-elements-core-utils';
import { PluginHost } from '../../plugin-host/plugin-host';
import { diaryTaskTracker } from './diary-plugins/diary-plugin';
import { ComposedSurveyPlugin } from '@hyper-inferno/survey-elements-core';
import { transformToComposedPlugin } from './diary-plugins/plugin-transformer';

@Component({
  selector: 'lib-survey-page',
  imports: [Page, PluginHost],
  templateUrl: './survey-page.html',
  styleUrl: './survey-page.css',
})
export class SurveyPage {
  surveyRenderStore = inject(SurveyRenderControllerStore);
  surveyBotController = inject(UnifiedSurveyStore);

  activeGlobalPlugins = computed<ComposedSurveyPlugin[]>(() => {

    const actualGlobalPlugins = this.surveyRenderStore.globalPlugins()

    const extraComposedPlugins = [
      transformToComposedPlugin(diaryTaskTracker,
        actualGlobalPlugins.find((plugin) => plugin.usageId === 'fe32af70-8715-45b3-a5fb-ee4467ebc054')?.answerObject ?? {})
    ]

    return actualGlobalPlugins
    return []
  })

  // Inject platform ID to detect web/mobile execution environment
  private platformId = inject(PLATFORM_ID);

  /**
   * Evaluates whether the current environment is a mobile / Flutter WebView environment.
   */
  private checkIfMobile(): boolean {
    // Strategy A: Check for global Flutter bridge / webview environment
    if (
      (typeof window !== 'undefined' && (window as any).flutter_inappwebview) ||
      (window as any).webkit?.messageHandlers?.flutter
    ) {
      return true;
    }

    // Strategy B: Fallback to checking if it is a browser environment (if it renders via capacitor/ionic etc.)
    // return isPlatformBrowser(this.platformId);

    return false;
  }

  onPageAction($event: { type: InteractionTypes; payload?: any }) {
    switch ($event.type) {
      case InteractionTypes.SUBMIT:
        return this.onSubmit();
      case InteractionTypes.SWITCH:
        return this.surveyBotController.onSwitchQuestionClick(
          $event.payload ?? false,
        );
      default:
        break;
    }
  }

  async onSubmit() {
    const submissionResult = await this.surveyBotController.attemptSubmit();
    if (await submissionResult.pageValid) {
      this.scrollToTop();
      this.surveyBotController.onSubmitButtonClick();
    } else if (submissionResult.firstInvalidId) {
      this.scrollToElement(submissionResult.firstInvalidId);
    }
  }

  private scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  private scrollToElement(elementId: string) {
    // We look for the element in the DOM.
    // Ensure your question components have [id]="element.id" in their HTML.
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}
